var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"id":"home-footer","min-height":"72"}},[_c('div',{staticClass:"site-footer__logo"},[_c('p',[_vm._v("© Copyright since 2018")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }